import React from 'react';
import { Heading, Body, Pill, Flex } from '@edreamsodigeo/prisma-design-system';
import PropTypes from 'prop-types';

export const HeaderWithBadge = ({
  badge,
  heading,
  badgeType = 'promotional',
}) => {
  return (
    <Flex flexDirection="column" gap="base" data-testid="header-with-badge">
      {badge && (
        <Pill
          data-testid="header-badge"
          type={badgeType}
          rounded
          sx={{ display: 'inline-flex', width: 'fit-content' }}
        >
          <Body weight="normal" type="small">
            {badge}
          </Body>
        </Pill>
      )}
      <Heading
        type="2"
        weight="medium"
        color="neutral.90"
        data-testid="header-heading"
      >
        {heading}
      </Heading>
    </Flex>
  );
};

HeaderWithBadge.propTypes = {
  badge: PropTypes.string,
  heading: PropTypes.string.isRequired,
  badgeType: PropTypes.oneOf([
    'promotional',
    'informative',
    'neutral',
    'positive',
    'negative',
    'brand',
    'deals',
    'warning',
  ]),
};
